// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__37Rmj","unreadBadge":"styles_unreadBadge__3YnWv","modalContent":"styles_modalContent__39lzt","modal":"styles_modal__3JTV_"};